<template>
  <main-content v-if="current_user.id">
    <kt-panel-header-toolbar>
      <ul class="nav nav-pills" role="tablist">
        <li class="nav-item">
          <a :class="['nav-link', currentTab === 1 ? 'active' : '']" href="#transfer"
             @click="currentTab = 1">
            {{ $t('application.services.transfer') }}
          </a>
        </li>

        <li class="nav-item">
          <a :class="['nav-link', currentTab === 2 ? 'active' : '']" href="#invoice"
             @click="currentTab = 2">
            {{ $t('application.services.invoice') }}
          </a>
        </li>

        <li class="nav-item">
          <a :class="['nav-link', currentTab === 3 ? 'active' : '']" href="#excel-export"
             @click="currentTab = 3">
            {{ $t('application.services.export_excel') }}
          </a>
        </li>
      </ul>
    </kt-panel-header-toolbar>
    <div class="tab-content">
      <div :class="['tab-pane', currentTab === 1 ? 'active' : '']">
        <admin-banking-transfer v-if="$can('read', 'open-banking') && currentTab === 1"></admin-banking-transfer>
        <user-banking-transfer v-else-if="currentTab === 1"></user-banking-transfer>
      </div>
      <div :class="['tab-pane', currentTab === 2 ? 'active' : '']">
        <admin-open-banking-statements v-if="$can('read', 'open-banking') && currentTab === 2" ></admin-open-banking-statements>
        <common-open-banking-statements v-else-if="currentTab === 2" ></common-open-banking-statements>
      </div>
      <div :class="['tab-pane', currentTab === 3 ? 'active' : '']">
        <open-banking-excel-export v-if="$can('read', 'open-banking') && currentTab === 3" ></open-banking-excel-export>
      </div>
    </div>
  </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import {mapGetters} from "vuex";
import AdminBankingTransfer from "@/views/openBanking/components/manage-access/open-banking-transfer.vue";
import UserBankingTransfer from "@/views/openBanking/components/common-access/open-banking-transfers.vue";
import AdminOpenBankingStatements from "@/views/openBanking/components/manage-access/open-banking-statements.vue";
import CommonOpenBankingStatements from "@/views/openBanking/components/common-access/open-banking-statements.vue";
import OpenBankingExcelExport from "@/views/openBanking/components/excel-export.vue";

export default {
  components: {
    OpenBankingExcelExport,
    AdminOpenBankingStatements,
    CommonOpenBankingStatements,
    AdminBankingTransfer,
    UserBankingTransfer,
    'main-content': mainContent,
  },
  data() {
    return {
      headerAction: {
        left: '10px',
        top: '10px',
        position: 'absolute',
      },
      currentTab: 1,
    }
  },
  computed: {
    ...mapGetters('user', [
      'current_user'
    ]),
  }
}
</script>

<style>
.switch-div {
  width: fit-content;
  padding: 8px 27px;
  background: #fff;
  box-shadow: 0 0 7px 0 #9c9c9c5e;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #6aad27;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 50px;
}

.slider.round:before {
  border-radius: 50px;
}

.info-icon {
  cursor: pointer;
  color: #0f9af0;
  display: inline-block;
}
</style>